import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';

export interface TotalMatchingGuestProfileHistory {
    cursor?: string;
    totalProfileMatches: number;
    previousMatchId?: string;
}

interface TotalMatchingGuestProfileStore {
    totalMatchingGuestProfileHistory: TotalMatchingGuestProfileHistory;
    setTotalMatchingGuestProfileHistory: (history: TotalMatchingGuestProfileHistory) => void;
    updateTotalMatchingGuestProfileHistory: (history: TotalMatchingGuestProfileHistory) => void;
}

const initialState: TotalMatchingGuestProfileHistory = { totalProfileMatches: 0 };

const totalMatchingGuestProfileStore = createStore<TotalMatchingGuestProfileStore>((set) => ({
    totalMatchingGuestProfileHistory: initialState,
    setTotalMatchingGuestProfileHistory: (totalMatchingGuestProfileHistory) =>
        set({ totalMatchingGuestProfileHistory }),
    updateTotalMatchingGuestProfileHistory: (totalMatchingGuestProfileHistory) =>
        set((state) => ({
            ...state,
            totalMatchingGuestProfileHistory: {
                ...state.totalMatchingGuestProfileHistory,
                ...totalMatchingGuestProfileHistory,
            },
        })),
}));

export const { setTotalMatchingGuestProfileHistory, updateTotalMatchingGuestProfileHistory } =
    totalMatchingGuestProfileStore.getState();

export const useTotalMatchingGuestProfileHistory = () =>
    useStore(totalMatchingGuestProfileStore, (store) => store.totalMatchingGuestProfileHistory);
